export default function moneyFormatter(value: number) {
  if (value) {
    const fractionDigits = Math.abs(value) < 1 ? 3 : 2;
    return value.toLocaleString("pt-BR", {
      useGrouping: true,
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  } else {
    return "R$ 0,00";
  }
}

export function moneyFormatterWithoutCurrency(value: number) {
  return moneyFormatter(value).replace("R$", "").replace(/\s/g, "");
}

export function moneyCentsFormatter(value: number) {
  if (value) {
    const valueInReais = value / 100;
    const fractionDigits = Math.abs(valueInReais) < 1 ? 3 : 2;
    return valueInReais.toLocaleString("pt-BR", {
      useGrouping: true,
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: fractionDigits,
      maximumFractionDigits: fractionDigits,
    });
  } else {
    return "R$ 0,00";
  }
}

export function moneyCentsFormatterWithoutCurrency(value: number) {
  return moneyCentsFormatter(value).replace("R$", "").replace(/\s/g, "");
}
